import type { AppMode } from '@iheartjane/types';

import type { GoldConfig, Store } from '@jane/shared/types';
import { Storage, statePostalCode } from '@jane/shared/util';

export const checkLocationAndStoreId = (
  goldConfig: GoldConfig,
  appMode: AppMode,
  store?: {
    id?: string | number;
    state?: string | null;
  }
): boolean => {
  const id = store?.id;
  const state =
    statePostalCode((store as Store)?.state) || Storage.get('state') || '';

  if (appMode === 'default' && !!state) {
    return goldConfig.states.includes(state);
  }

  // For all other app modes, check the store ID
  if (id) {
    return goldConfig.store_ids.includes(Number(id));
  }

  return false;
};
